import { createApi, fetchBaseQuery, } from "@reduxjs/toolkit/query/react";
import { ETCRM_LEGACY_URL, } from "@/utils/const";
// import { RootState } from "..";
import { logger } from "@/utils/loggerService";
import { createBaseQueryWithReauth } from "../api";
/**
 * Requête de base
 */
var baseQuery = fetchBaseQuery({
    baseUrl: ETCRM_LEGACY_URL,
    prepareHeaders: function (headers, _a) {
        var getState = _a.getState;
        var state = getState();
        var token = state.auth.token;
        logger.debug("[baseQuery/prepareHeaders] - Modification du 'Content-Type' par 'application/json'");
        headers.set("Content-Type", "application/json");
        headers.set("Content-Type", "application/json");
        if (token) {
            logger.debug("[baseQuery/prepareHeaders] - Rattachement du token d'identification aux requ\u00EAtes", token);
            headers.set("Authorization", "Bearer ".concat(token));
            return headers;
        }
    },
    validateStatus: function (response, result) {
        return response.status >= 200 &&
            response.status <= 299 &&
            ((result === null || result === void 0 ? void 0 : result.access_token) || (result === null || result === void 0 ? void 0 : result.status) === "success");
    },
});
/**
 * Slice pour la gestion des appels Api MCV (legacy)
 */
export var mvcApiSlice = createApi({
    reducerPath: "mvcApi",
    baseQuery: createBaseQueryWithReauth(baseQuery),
    tagTypes: [],
    endpoints: function (builder) { return ({
        getModuleView: builder.query({
            query: function (_a) {
                var moduleName = _a.moduleName, action = _a.action, record = _a.record;
                return "?module=".concat(moduleName, "&action=").concat(action, "&record=").concat(record);
            },
        }),
    }); },
});
export var useGetModuleViewQuery = mvcApiSlice.useGetModuleViewQuery;
